import Icon from '@jimmyboys/liita-ui/dist/components/Icon'
import TextInput from '@jimmyboys/liita-ui/dist/components/TextInput'
import styles from './TextSearchInput.module.sass'

const TextSearchInput = (props) => {
	const { onChange, placeholder, className, disabled = false } = props

	return (
		<>
			<div className={`${styles['search-input']} ${className || ''}`}>
				<TextInput
					placeholder={placeholder}
					className={styles['text-input']}
					debounce={500}
					onChange={({ target: { value } }) => {
						onChange && onChange(value)
					}}
					disabled={disabled}
				/>
				<Icon
					className={styles['input-icon']}
					name='loupe'
					width='18px'
					height='18px'
				/>
			</div>
		</>
	)
}

export default TextSearchInput
